import DuckEntity from './DuckEntity'

const entity = new DuckEntity('mmsHistories');
const reducer = entity.reducer;
export {reducer as default, entity};
